import type { VAxios } from '../../define/axios/Axios';

interface InpaintJob {
  baseModel?: string;
  imageUrl: string;
  maskUrl: string;
  referenceUrl?: string;
  num?: number;
  degree?: number;
  prompt?: string;
  removeMode?: boolean;
  expand?: boolean;
  uploadAddress: {
    accessKeyId?: string;
    accessKeySecret?: string;
    bucketName?: string;
    endpoint?: string;
    folder?: string;
    securityToken?: string;
  };
}
interface InpaintResult {
  createBy: string;
  createTime: Record<string, unknown>;
  files: {
    height: number;
    name: string;
    size: number;
    url: string;
    width: number;
  }[];
  finished: boolean;
  id: number;
  message: string;
  modifyBy: string;
  modifyTime: Record<string, unknown>;
  progress: string;
  status: string;
  succeed: boolean;
}

/**
 * inpaint 相关接口
 */
export const createApi = (defHttp: VAxios) => ({
  // 提交任务
  createJob: (params: InpaintJob) => defHttp.post({ url: `/editor/inpaint/jobs`, params }),
  // 根据ID查询任务结果
  queryJobResult: (id) => defHttp.get<InpaintResult>({ url: `/editor/inpaint/jobs/${id}` }),
});
